import { Layout, LayoutBlock, LayoutEditForm } from './Layout';

import { GuidHelper } from 'Code/Helpers/GuidHelper';
import { LayoutColumn } from './LayoutColumn';
import { LayoutField } from './LayoutField';
import { LayoutRow } from './LayoutRow';
import { LayoutSubgrid } from './LayoutSubgrid';
import { LayoutViewBlock } from './LayoutViewBlock';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from 'Code/Helpers/StringHelper';

export class LayoutHelper {

    public static async CreateDefaultLayout(schema: Object): Promise<Layout> {
        if (!ObjectHelper.ObjectIs(schema)) {
            return new Layout();
        }

        // create layout instance
        let layout: Layout = new Layout();

        // Init after page load script as empty string
        layout.AfterPageLoadScript = StringHelper.Empty();

        layout = await this.CreateDefaultViewBlocks(schema, layout);

        //
        layout = await this.CreateDefaultEditForm(schema, layout);
        layout = await this.CreateDefaultSubgrids(schema, layout);

        // create new view block for buttons
        let newViewBlockButtons = new LayoutViewBlock();
        newViewBlockButtons.Id = GuidHelper.NewGuid();
        newViewBlockButtons.Name = 'Buttons';
        layout.ViewBlocks.push(newViewBlockButtons);

        // create new view block for footer
        let newViewBlockFooter = new LayoutViewBlock();
        newViewBlockFooter.Id = GuidHelper.NewGuid();
        newViewBlockFooter.Name = 'EditFormFooter';
        layout.ViewBlocks.push(newViewBlockFooter);

        // Return new default layout
        return layout;
    }

    public static async CreateDefaultListLayout(schema: Object, dashboard?: boolean): Promise<Layout> {

        //
        let layout: Layout = new Layout();

        //
        layout.AfterPageLoadScript = StringHelper.Empty();

        // Init view blocks
        layout.ViewBlocks = new Array<LayoutViewBlock>();

        // create new view block for edit form
        let newViewBlockForm = new LayoutViewBlock();
        newViewBlockForm.Id = GuidHelper.NewGuid();
        newViewBlockForm.Name = 'EditForm';
        layout.ViewBlocks.push(newViewBlockForm);

        //
        layout.EditForm = new LayoutEditForm();
        layout.EditForm.Rows = new Array<LayoutRow>();

        if (ObjectHelper.IsNotNullAndUndefinedAndEmpty(schema)) {
            layout = await this.CreateDefaultFilterForm(schema, layout);
            layout = await this.CreateDefaultSubgrids(schema, layout);
        }

        // create new view block for buttons
        let newViewBlockButtons = new LayoutViewBlock();
        newViewBlockButtons.Id = GuidHelper.NewGuid();
        newViewBlockButtons.Name = 'Buttons';
        layout.ViewBlocks.push(newViewBlockButtons);

        if (dashboard) {
            // create new view block for buttons
            let newViewBlockDashboard = new LayoutViewBlock();
            newViewBlockDashboard.Id = GuidHelper.NewGuid();
            newViewBlockDashboard.Name = 'Dashboard';
            layout.ViewBlocks.push(newViewBlockDashboard);
        }

        //
        return layout;
    }

    public static async CreateDefaultDashboardLayout(schema: Object): Promise<Layout> {

        //
        let layout: Layout = new Layout();

        //
        layout.AfterPageLoadScript = StringHelper.Empty();

        // Init view blocks
        layout.ViewBlocks = new Array<LayoutViewBlock>();

        // create new view block for edit form
        let newViewBlockForm = new LayoutViewBlock();
        newViewBlockForm.Id = GuidHelper.NewGuid();
        newViewBlockForm.Name = 'EditForm';
        layout.ViewBlocks.push(newViewBlockForm);

        //
        layout.EditForm = new LayoutEditForm();
        layout.EditForm.Rows = new Array<LayoutRow>();

        layout = await this.CreateDefaultDashboardForm(schema, layout);

        //
        return layout;
    }

    public static async CreateDefaultLEmailLayout(schema: Object): Promise<Layout> {

        //
        let layout: Layout = new Layout();

        //
        layout.AfterPageLoadScript = StringHelper.Empty();

        // Init view blocks
        layout.ViewBlocks = new Array<LayoutViewBlock>();

        // create new view block for edit form
        let newViewBlockForm = new LayoutViewBlock();
        newViewBlockForm.Id = GuidHelper.NewGuid();
        newViewBlockForm.Name = 'EditForm';
        layout.ViewBlocks.push(newViewBlockForm);

        //
        layout.EditForm = new LayoutEditForm();
        layout.EditForm.Rows = new Array<LayoutRow>();

        layout = await this.CreateDefaultFilterForm(schema, layout);

        //
        return layout;
    }

    private static async CreateDefaultViewBlocks(schema: Object, layout: Layout): Promise<Layout> {

        // Init view blocks
        layout.ViewBlocks = new Array<LayoutViewBlock>();


        // create new view block for footer
        let newViewBlockFooterTop = new LayoutViewBlock();
        newViewBlockFooterTop.Id = GuidHelper.NewGuid();
        newViewBlockFooterTop.Name = 'EditFormFooter';
        layout.ViewBlocks.push(newViewBlockFooterTop);

        // create new view block for buttons
        let newViewBlockButtonsTop = new LayoutViewBlock();
        newViewBlockButtonsTop.Id = GuidHelper.NewGuid();
        newViewBlockButtonsTop.Name = 'Buttons';
        layout.ViewBlocks.push(newViewBlockButtonsTop);

        // create new view block for edit form
        let newViewBlockForm = new LayoutViewBlock();
        newViewBlockForm.Id = GuidHelper.NewGuid();
        newViewBlockForm.Name = 'EditForm';
        layout.ViewBlocks.push(newViewBlockForm);

        //
        layout.EditForm = new LayoutEditForm();
        layout.EditForm.Rows = new Array<LayoutRow>();

        //
        return layout;
    }

    private static async CreateDefaultEditForm(schema: Object, layout: Layout): Promise<Layout> {

        //
        let newRowForFields = new LayoutRow();
        newRowForFields.Id = GuidHelper.NewGuid();
        newRowForFields.Blocks = new Array<LayoutBlock>();

        //
        let blockCount = 3;

        //
        for (var i = 1; i <= blockCount; i++) {

            //
            let fieldBlock = new LayoutBlock();

            //
            fieldBlock.Id = GuidHelper.NewGuid();
            fieldBlock.BlockSize = blockCount;
            fieldBlock.BlockTitle = 'New block ' + i.toString();
            fieldBlock.BlockType = 'Form';
            fieldBlock.Columns = new Array<LayoutColumn>();
            fieldBlock.BlockBorderColor = 'panel-default';

            //
            let fieldColumn = new LayoutColumn();
            fieldColumn.Id = GuidHelper.NewGuid();
            fieldColumn.ColumnSize = 1;
            fieldColumn.Fields = new Array<LayoutField>();

            //
            fieldBlock.Columns.push(fieldColumn);

            //
            newRowForFields.Blocks.push(fieldBlock);
        }

        //
        layout.EditForm.Rows.push(newRowForFields);

        //
        if (ObjectHelper.IsNotNullAndUndefined(schema) && schema['Columns'] != null) {
            let allFieldsWithoutDescr = schema['Columns'].filter((item) => item['Type_FK'] != 6 && item.hasOwnProperty('IsVisibleOnForm') && item['IsVisibleOnForm'] == true);

            //
            let counter = 0;

            //
            for (var index = 0; index < allFieldsWithoutDescr.length; index++) {
                let item = allFieldsWithoutDescr[index];

                let field = new LayoutField();
                field.FieldName = item['ColumnName'];
                //field.FieldTitle = item['LocalizationString'];

                layout.EditForm.Rows[0].Blocks[counter].Columns[0].Fields.push(field);

                counter = (counter == (blockCount - 1)) ? 0 : (counter + 1)
            }
        }




        if (schema['CategoriesEnabled'] != null && schema['CategoriesEnabled'] == true) {
            //
            let newRowForCat = new LayoutRow();
            newRowForCat.Id = GuidHelper.NewGuid();
            newRowForCat.Blocks = new Array<LayoutBlock>();

            //
            let catBlock = new LayoutBlock();

            //
            catBlock.Id = GuidHelper.NewGuid();
            catBlock.BlockSize = 1;
            catBlock.BlockTitle = 'Categories';
            catBlock.BlockType = 'Category';
            catBlock.Columns = new Array<LayoutColumn>();
            catBlock.BlockBorderColor = 'panel-default';

            //
            let catColumn = new LayoutColumn();
            catColumn.Id = GuidHelper.NewGuid();
            catColumn.ColumnSize = 1;
            catColumn.Fields = null;

            catBlock.Columns.push(catColumn);
            newRowForCat.Blocks.push(catBlock);
            layout.EditForm.Rows.push(newRowForCat);
        }

        if (schema['ParticipantEnabled'] != null && schema['ParticipantEnabled'] == true) {
            //
            let newRowForPart = new LayoutRow();
            newRowForPart.Id = GuidHelper.NewGuid();
            newRowForPart.Blocks = new Array<LayoutBlock>();

            //
            let partBlock = new LayoutBlock();

            //
            partBlock.Id = GuidHelper.NewGuid();
            partBlock.BlockSize = 1;
            partBlock.BlockTitle = 'Participants';
            partBlock.BlockType = 'Participant';
            partBlock.Columns = new Array<LayoutColumn>();
            partBlock.BlockBorderColor = 'panel-default';

            //
            let partColumn = new LayoutColumn();
            partColumn.Id = GuidHelper.NewGuid();
            partColumn.ColumnSize = 1;
            partColumn.Fields = null;

            partBlock.Columns.push(partColumn);
            newRowForPart.Blocks.push(partBlock);
            layout.EditForm.Rows.push(newRowForPart);
        }

        if (schema['DiscussionEnabled'] != null && schema['DiscussionEnabled'] == true) {
            //
            let newRowForDist = new LayoutRow();
            newRowForDist.Id = GuidHelper.NewGuid();
            newRowForDist.Blocks = new Array<LayoutBlock>();

            //
            let distBlock = new LayoutBlock();

            //
            distBlock.Id = GuidHelper.NewGuid();
            distBlock.BlockSize = 1;
            distBlock.BlockTitle = 'DiscussionSendMess';
            distBlock.BlockType = 'DiscussionSendMess';
            distBlock.Columns = new Array<LayoutColumn>();
            distBlock.BlockBorderColor = 'panel-default';

            //
            let distColumn = new LayoutColumn();
            distColumn.Id = GuidHelper.NewGuid();
            distColumn.ColumnSize = 1;
            distColumn.Fields = null;

            distBlock.Columns.push(distColumn);
            newRowForDist.Blocks.push(distBlock);
            layout.EditForm.Rows.push(newRowForDist);
        }

        if (schema['DocumentEnabled'] != null && schema['DocumentEnabled'] == true) {
            //
            let newRowForDist = new LayoutRow();
            newRowForDist.Id = GuidHelper.NewGuid();
            newRowForDist.Blocks = new Array<LayoutBlock>();

            //
            let distBlock = new LayoutBlock();

            //
            distBlock.Id = GuidHelper.NewGuid();
            distBlock.BlockSize = 1;
            distBlock.BlockTitle = 'DocumentUpload';
            distBlock.BlockType = 'DocumentUpload';
            distBlock.Columns = new Array<LayoutColumn>();
            distBlock.BlockBorderColor = 'panel-default';

            //
            let distColumn = new LayoutColumn();
            distColumn.Id = GuidHelper.NewGuid();
            distColumn.ColumnSize = 1;
            distColumn.Fields = null;

            distBlock.Columns.push(distColumn);
            newRowForDist.Blocks.push(distBlock);
            layout.EditForm.Rows.push(newRowForDist);
        }

        let allDecsrFields = schema['Columns'].filter((item) => item['Type_FK'] == 6 && item.hasOwnProperty('IsVisibleOnForm') && item['IsVisibleOnForm'] == true);

        for (var index = 0; index < allDecsrFields.length; index++) {
            let item = allDecsrFields[index];

            //
            let newRowForDescr = new LayoutRow();
            newRowForDescr.Id = GuidHelper.NewGuid();
            newRowForDescr.Blocks = new Array<LayoutBlock>();

            //
            let descrBlock = new LayoutBlock();

            //
            descrBlock.Id = GuidHelper.NewGuid();
            descrBlock.BlockSize = 1;
            descrBlock.BlockTitle = item['LocalizationString'];
            descrBlock.BlockType = 'Form';
            descrBlock.Columns = new Array<LayoutColumn>();
            descrBlock.BlockBorderColor = 'panel-default';

            //
            let descrColumn = new LayoutColumn();
            descrColumn.Id = GuidHelper.NewGuid();
            descrColumn.ColumnSize = 1;
            descrColumn.Fields = new Array<LayoutField>();

            //
            let field = new LayoutField();
            field.FieldName = item['ColumnName'];
            //field.FieldTitle = item['LocalizationString'];
            field.NoLabel = true;

            //
            descrColumn.Fields.push(field);
            descrBlock.Columns.push(descrColumn);
            newRowForDescr.Blocks.push(descrBlock);
            layout.EditForm.Rows.push(newRowForDescr);
        }





        if (ObjectHelper.IsNotNullAndUndefined(schema['ItemGrid']) && schema['ItemGrid'].length > 0) {

            //
            for (var index = 0; index < schema['ItemGrid'].length; index++) {
                let item = schema['ItemGrid'][index];

                //
                let newRowForIG = new LayoutRow();
                newRowForIG.Id = GuidHelper.NewGuid();
                newRowForIG.Blocks = new Array<LayoutBlock>();

                //
                let igBlock = new LayoutBlock();

                //
                igBlock.Id = GuidHelper.NewGuid();
                igBlock.BlockSize = 1;
                igBlock.BlockTitle = item['EntityName'];
                igBlock.BlockType = 'ItemGrid';
                igBlock.Columns = new Array<LayoutColumn>();
                igBlock.EntityName = item['EntityName'];
                igBlock.BlockBorderColor = 'panel-default';

                //
                let igColumn = new LayoutColumn();
                igColumn.Id = GuidHelper.NewGuid();
                igColumn.ColumnSize = 1;
                igColumn.Fields = null;

                //
                igBlock.Columns.push(igColumn);
                newRowForIG.Blocks.push(igBlock);
                layout.EditForm.Rows.push(newRowForIG);
            }
        }


        if (ObjectHelper.IsNotNullAndUndefined(schema['Attachment']) && schema['Attachment'].length > 0) {

            //
            for (var index = 0; index < schema['Attachment'].length; index++) {
                let item = schema['Attachment'][index];

                //
                let newRowForAttach = new LayoutRow();
                newRowForAttach.Id = GuidHelper.NewGuid();
                newRowForAttach.Blocks = new Array<LayoutBlock>();

                //
                let attachBlock = new LayoutBlock();

                //
                attachBlock.Id = GuidHelper.NewGuid();
                attachBlock.BlockSize = 1;
                attachBlock.BlockTitle = item['EntityName'];
                attachBlock.BlockType = 'Attachment';
                attachBlock.Columns = new Array<LayoutColumn>();
                attachBlock.EntityName = item['EntityName'];
                attachBlock.BlockBorderColor = 'panel-default';

                //
                let attachColumn = new LayoutColumn();
                attachColumn.Id = GuidHelper.NewGuid();
                attachColumn.ColumnSize = 1;
                attachColumn.Fields = null;

                //
                attachBlock.Columns.push(attachColumn);
                newRowForAttach.Blocks.push(attachBlock);
                layout.EditForm.Rows.push(newRowForAttach);
            }
        }


        if (ObjectHelper.IsNotNullAndUndefined(schema['ItemMasterGrid']) && schema['ItemMasterGrid'].length > 0) {

            //
            for (var index = 0; index < schema['ItemMasterGrid'].length; index++) {
                let item = schema['ItemMasterGrid'][index];

                //
                let newRowForIMG = new LayoutRow();
                newRowForIMG.Id = GuidHelper.NewGuid();
                newRowForIMG.Blocks = new Array<LayoutBlock>();

                //
                let imgBlock = new LayoutBlock();

                //
                imgBlock.Id = GuidHelper.NewGuid();
                imgBlock.BlockSize = 1;
                imgBlock.BlockTitle = item['EntityName'];
                imgBlock.BlockType = 'ItemMasterGrid';
                imgBlock.Columns = new Array<LayoutColumn>();
                imgBlock.EntityName = item['EntityName'];
                imgBlock.BlockBorderColor = 'panel-default';

                //
                let imgColumn = new LayoutColumn();
                imgColumn.Id = GuidHelper.NewGuid();
                imgColumn.ColumnSize = 1;
                imgColumn.Fields = null;

                //
                imgBlock.Columns.push(imgColumn);
                newRowForIMG.Blocks.push(imgBlock);
                layout.EditForm.Rows.push(newRowForIMG);
            }
        }




        if (ObjectHelper.IsNotNullAndUndefined(schema['ManyToManyGrid']) && schema['ManyToManyGrid'].length > 0) {
            for (var index = 0; index < schema['ManyToManyGrid'].length; index++) {
                let item = schema['ManyToManyGrid'][index];

                let newRowForMTM = new LayoutRow();
                newRowForMTM.Id = GuidHelper.NewGuid();
                newRowForMTM.Blocks = new Array<LayoutBlock>();

                //
                let mtmBlock = new LayoutBlock();

                //
                mtmBlock.Id = GuidHelper.NewGuid();
                mtmBlock.BlockSize = 1;
                mtmBlock.BlockTitle = item['EntityName'];
                mtmBlock.BlockType = 'ManyToMany';
                mtmBlock.Columns = new Array<LayoutColumn>();
                mtmBlock.EntityName = item['EntityName'];
                mtmBlock.BlockBorderColor = 'panel-default';

                //
                let mtmColumn = new LayoutColumn();
                mtmColumn.Id = GuidHelper.NewGuid();
                mtmColumn.ColumnSize = 1;
                mtmColumn.Fields = null;

                //
                mtmBlock.Columns.push(mtmColumn);
                newRowForMTM.Blocks.push(mtmBlock);
                layout.EditForm.Rows.push(newRowForMTM);
            }
        }

        return layout;
    }

    private static async CreateDefaultSubgrids(schema: Object, layout: Layout): Promise<Layout> {

        if (ObjectHelper.IsNotNullAndUndefined(schema)) {
            let newViewBlockSubgrid = new LayoutViewBlock();
            newViewBlockSubgrid.Id = GuidHelper.NewGuid();
            newViewBlockSubgrid.Name = 'Subgrids';
            layout.ViewBlocks.push(newViewBlockSubgrid);
            layout.Subgrids = new Array<LayoutSubgrid>();

            if (ObjectHelper.IsNotNullAndUndefined(schema['SubGrid']) && schema['SubGrid'].length > 0) {
                for (var index = 0; index < schema['SubGrid'].length; index++) {
                    let newSubgrid = new LayoutSubgrid();
                    newSubgrid.EntityName = schema['SubGrid'][index]['EntityName'];
                    newSubgrid.ProjectionRelationName = schema['SubGrid'][index]['ProjectionRelationName'];
                    newSubgrid.IsDefault = (index == 0);
                    layout.Subgrids.push(newSubgrid);
                }
            }
        }

        return layout;
    }

    private static async CreateDefaultFilterForm(schema: Object, layout: Layout): Promise<Layout> {

        //
        let newRowForFields = new LayoutRow();
        newRowForFields.Id = GuidHelper.NewGuid();
        newRowForFields.Blocks = new Array<LayoutBlock>();

        //
        let columnCount = 3;
        if (schema["EntityName"] == 'CalendarFilter') {
            columnCount = 2;
        }

        //
        let fieldBlock = new LayoutBlock();

        //
        fieldBlock.Id = GuidHelper.NewGuid();
        fieldBlock.BlockSize = 1;
        fieldBlock.BlockTitle = 'Filter';
        fieldBlock.BlockType = 'Form';
        fieldBlock.Columns = new Array<LayoutColumn>();
        fieldBlock.BlockBorderColor = 'panel-default';

        //
        for (var i = 1; i <= columnCount; i++) {

            //
            let fieldColumn = new LayoutColumn();
            fieldColumn.Id = GuidHelper.NewGuid();
            fieldColumn.ColumnSize = columnCount;
            fieldColumn.Fields = new Array<LayoutField>();

            //
            fieldBlock.Columns.push(fieldColumn);
        }

        //
        newRowForFields.Blocks.push(fieldBlock);

        //
        layout.EditForm.Rows.push(newRowForFields);

        //
        if (ObjectHelper.IsNotNullAndUndefined(schema) && schema['Columns'] != null) {
            let allFieldsWithoutDescr = schema['Columns'].filter((item) => item['Type_FK'] != 6 && item.hasOwnProperty('IsVisibleOnFilter') && item['IsVisibleOnFilter'] == true);

            //
            let counter = 0;

            //
            for (var index = 0; index < allFieldsWithoutDescr.length; index++) {
                let item = allFieldsWithoutDescr[index];

                let field = new LayoutField();
                field.FieldName = item['ColumnName'];
                //field.FieldTitle = item['LocalizationString'];

                layout.EditForm.Rows[0].Blocks[0].Columns[counter].Fields.push(field);

                counter = (counter == (columnCount - 1)) ? 0 : (counter + 1)
            }
        }

        //
        return layout;
    }

    private static async CreateDefaultDashboardForm(schema: Object, layout: Layout): Promise<Layout> {

        //
        let newRowForFields = new LayoutRow();
        newRowForFields.Id = GuidHelper.NewGuid();
        newRowForFields.Blocks = new Array<LayoutBlock>();

        //
        let columnCount = 3;

        //
        let fieldBlock = new LayoutBlock();

        //
        fieldBlock.Id = GuidHelper.NewGuid();
        fieldBlock.BlockSize = 1;
        fieldBlock.BlockTitle = 'Dashboard';
        fieldBlock.BlockType = 'Form';
        fieldBlock.Columns = new Array<LayoutColumn>();
        fieldBlock.BlockBorderColor = 'panel-default';

        //
        for (var i = 1; i <= columnCount; i++) {

            //
            let fieldColumn = new LayoutColumn();
            fieldColumn.Id = GuidHelper.NewGuid();
            fieldColumn.ColumnSize = columnCount;
            fieldColumn.Fields = new Array<LayoutField>();

            //
            fieldBlock.Columns.push(fieldColumn);
        }

        //
        newRowForFields.Blocks.push(fieldBlock);

        //
        layout.EditForm.Rows.push(newRowForFields);

        // //
        // if (ObjectHelper.IsNotNullAndUndefined(schema) && schema['Columns'] != null) {
        //     let allFieldsWithoutDescr = schema['Columns'].filter((item) => item['Type_FK'] != 6 && item.hasOwnProperty('IsVisibleOnFilter') &&  item['IsVisibleOnFilter'] == true);

        //     //
        //     let counter = 0;

        //     //
        //     for (let index in allFieldsWithoutDescr) {
        //         let item = allFieldsWithoutDescr[index];

        //         let field = new LayoutField();
        //         field.FieldName = item['ColumnName'];
        //         //field.FieldTitle = item['LocalizationString'];

        //         layout.EditForm.Rows[0].Blocks[0].Columns[counter].Fields.push(field);

        //         counter = (counter == (columnCount - 1)) ? 0 : (counter + 1)
        //     }
        // }

        //
        return layout;
    }
}